import { uniqueIssues, type EntityRef, type ValidationEvaluation } from "@shared/validation/issues";

type CheckedRecord = ValidationEvaluation & { entity: EntityRef };
/** A later relationship pass is not a retraction of the earlier domain pass.
 * Retain all observed findings and incomplete checks throughout this rolling
 * scan; only starting a new scan can replace its accumulated evidence. */
export function mergeScanRecords<T extends CheckedRecord>(before: readonly T[], incoming: readonly T[]): T[] {
  const records = new Map(before.map(record => [`${record.entity.type}:${record.entity.id}`, record]));
  for (const record of incoming) {
    const key = `${record.entity.type}:${record.entity.id}`, previous = records.get(key);
    records.set(key, previous ? { ...record, issues: uniqueIssues([...previous.issues, ...record.issues]), checksComplete: previous.checksComplete && record.checksComplete } : record);
  }
  return [...records.values()];
}
